import { render, staticRenderFns } from "./RealTimeIndex.vue?vue&type=template&id=51ff68dd&"
import script from "./RealTimeIndex.vue?vue&type=script&lang=js&"
export * from "./RealTimeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports